import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { Icon, Button } from '@pwc/pwc-deals-ui';
import { Link, useRouteMatch } from 'react-router-dom';
import {
  getEnablePowerBiIngestion,
  getEnableTableauProject,
  getWorkspaceId,
} from 'features/project/projectSlice';
import featureFlags from 'common/helpers/featureFlags';

const ObjectInjestPopoverContent = ({
  onCancel = () => {},
  onInsertText = () => {},
  onInsertPowerBi = () => {},
  onInsertTableau = () => {},
  onInsertExcelOrPPT = () => {},
  allowTextOnly,
  isPowerBiEnabled,
}) => {
  const { t } = useTranslation();
  const { url } = useRouteMatch();
  const workspaceId = useSelector(getWorkspaceId);
  const enableTableauProject = useSelector(getEnableTableauProject);
  const enablePowerBiIngestion = useSelector(getEnablePowerBiIngestion);

  const handleAddLibraryItem = async (e) => {
    e.preventDefault();
    onCancel();
    if (onInsertExcelOrPPT) {
      onInsertExcelOrPPT();
    }
  };

  const handlePowerBi = (e) => {
    e.preventDefault();
    onCancel();
    if (onInsertPowerBi) {
      onInsertPowerBi();
    }
  };

  const handleTableau = (e) => {
    e.preventDefault();
    onCancel();
    if (onInsertTableau) {
      onInsertTableau();
    }
  };

  const handleText = (e) => {
    e.preventDefault();
    onCancel();
    if (onInsertText) {
      onInsertText();
    }
  };

  const textOnlyIconClassName = `outline ${
    // eslint-disable-next-line no-constant-condition
    false ? 'icon-grey' : 'icon-grey-medium'
  }`;
  return (
    <>
      {allowTextOnly ? (
        <Button
          className="ui-button button-menu"
          buttonIconName="plus"
          buttonIconClass="outline icon-orange"
          placement="bottom"
          disabled
        >
          <Icon
            name="table-data"
            width={24}
            className={textOnlyIconClassName}
          />
          Excel or PowerPoint
        </Button>
      ) : (
        <Link
          className="ui-button button-menu"
          to={`${url}/library-items`}
          onClick={handleAddLibraryItem}
        >
          <Icon
            name="table-data"
            width={24}
            height={24}
            className="outline icon-orange-theme"
          />
          <span>{t('excelPowerPoint')}</span>
        </Link>
      )}
      {isPowerBiEnabled &&
        featureFlags.isPowerBiIngestionEnabled &&
        (allowTextOnly ? (
          <Button className="ui-button button-menu" disabled>
            <Icon
              name="powerbi-new"
              width={24}
              height={24}
              className={textOnlyIconClassName}
            />
            <span>{t('powerBIKFA')}</span>
          </Button>
        ) : (
          <Button
            className="ui-button button-menu"
            onClick={handlePowerBi}
            disabled={!enablePowerBiIngestion}
          >
            <Icon
              name="powerbi-new"
              width={24}
              height={24}
              className={
                enablePowerBiIngestion
                  ? 'outline icon-orange-theme'
                  : 'outline icon-grey-theme-disabled'
              }
            />
            <span>{t('powerBIKFA')}</span>
          </Button>
        ))}
      {featureFlags.isTableauEnabled && enableTableauProject && workspaceId && (
        <Button className="ui-button button-menu" onClick={handleTableau}>
          <Box
            sx={{
              transform: 'scale(1.4)',
              display: 'flex',
              position: 'relative',
              left: '1px',
            }}
          >
            <Icon
              name="grow-revenue-2"
              width={24}
              height={24}
              className="outline icon-orange-theme"
            />
          </Box>
          <span data-testid="tableau">Tableau</span>
        </Button>
      )}
      <Button className="ui-button button-menu" onClick={handleText}>
        <Icon
          name="textbox"
          width={24}
          height={24}
          className="outline icon-orange-theme"
        />
        <span>{t('text')}</span>
      </Button>
    </>
  );
};

export default ObjectInjestPopoverContent;
